import { isNud } from '@/shared/utilities/typing'

/**
 * 題材別評価 エンティティ
 */
class SubjectEvaluation {
    evaluation_score_1;
    evaluation_score_2;
    evaluation_score_3;
    evaluation_score_4;
    evaluation_score_5;
    teacher_note;

    constructor(properties) {
        if (isNud(properties)) {
            properties = {};
        }

        this.evaluation_score_1 = properties.evaluation_score_1;
        this.evaluation_score_2 = properties.evaluation_score_2;
        this.evaluation_score_3 = properties.evaluation_score_3;
        this.evaluation_score_4 = properties.evaluation_score_4;
        this.evaluation_score_5 = properties.evaluation_score_5;
        this.teacher_note = properties.teacher_note;
    }
}

export default SubjectEvaluation;
